// noinspection SqlDialectInspection

// User-visible sentences: empty-state bodies, validation and error text.
// Positional {0} placeholders are substituted by formatString (eone-ui).

export const Messages = {
    AcceptPricingPolicy: "I have read and accept the {0}.",
    AccountCancelled: "Your Popdock subscription was cancelled",
    AccountCancelledContactAdmin: "Your connectors and favorites are still here. Contact your account administrator to resubscribe.",
    AccountCancelledResubscribe: "Your connectors and favorites are still here. Resubscribe to turn them back on.",
    ActionCancelButtonLabelInfo: "When a confirmation prompt is entered, this label will be on the button that the user has to click to cancel the action",
    ActionConfirmationLabelInfo: "When a confirmation prompt is entered, the prompt will be displayed to the user to confirm the action before running it",
    ActionNameExists: "An action with this name already exists",
    ActionSubmitButtonLabelInfo: "When a confirmation prompt is entered, this label will be on the button that the user has to click to run the action",
    ActionSuccessful: "Your action has ran successfully!",
    AdaptiveCardNameExists: "An adaptive card with this name already exists",
    AddAnotherColor: "Add another color",
    AddAnotherColorCodingRule: "Add another rule",
    AddAnotherFilter: "Add another filter",
    AddAnotherGroupField: "Add another group field",
    AddAnotherJoin: "Add another join",
    AddConnectorDetails: "Add connector details",
    AddCustomDetail: "Add custom detail",
    AddFieldByNameAndPath: "Add a single field by supplying a name and path",
    AddFieldByRunningQuery: "Add fields by running the query",
    AddFieldFromParent: "Add a field from from the parent list",
    AddFieldsBySampleFile: "Add fields by reading from a sample file",
    AddingList: "Adding list",
    AddList: "Add list",
    AddGroupField: "Add group field",
    AddListItemCopy: "Copy existing list items",
    AddListItemFromConnector: "Update list items from the connector",
    AddListItemMultiple: "Add multiple list items from a csv file",
    AddListItemSingle: "Add a single list item",
    AddMatrixDynamicRowPrompt: "Add a set of rows that are auto-generated based on a field value",
    AddMatrixFilterColumnPrompt: "Add a column calculated by summarizing a field after applying filters",
    AddMatrixFilterRowPrompt: "Add a row that is calculated by running a summary on a field after applying filters",
    AddMatrixGeneratedColumnsPrompt: "Generate a set of columns based on a field",
    AddMatrixLabelColumnPrompt: "Add label column",
    AddMatrixSummaryRowPrompt: "Add a row that summarizes other rows",
    AddingColumns: "Adding columns...",
    AddingConnector: "Adding connector...",
    AddingEntities: "Adding lists...",
    AddingFields: "Adding fields...",
    AddingTables: "Adding tables...",
    AddOnNoteConnectorPack: "Five extra data connectors per pack",
    AddOnNoteExtendedRetention: "24 months of query history",
    AddOnNoteMcpToolPack: "Expose favorites as MCP tools",
    AddOnNoteUserPack: "Twenty-five extra named users per pack",
    AddOnsProratedFromToday: "Add-ons are prorated from today.",
    AddOnsStartTodayBillingAtRenewal: "Add-ons start today; the new billing period applies at renewal.",
    AddRedirectUrisAllowedAuthorizationCode: "Add the redirect URIs allowed for the authorization code flow.",
    AiSummaryPromptTooltip: "Tip: ask for specific metrics, exceptions, or comparisons.",
    AiToneModifierNameExists: "An AI tone modifier with this name already exists",
    AllActionsAdded: "All actions have been added",
    AllClientsMapped: "All clients have already been mapped.",
    AllColorsAdded: "All colors have been added",
    AllColumnsAdded: "All columns have been added",
    AllCompaniesAdded: "All {0} have been added",
    AllDoneReadyToWrapUp: "All done — ready to wrap up.",
    AllEntitiesAdded: "You have already added all lists",
    AllFieldsAddedForEntity: "All fields have been added for this list",
    AllFieldsAddedToEntity: "All fields have been added to the list",
    AllFieldsAddedToWidget: "All fields have been added to the widget",
    AllFileTypesAllowed: "All file types are allowed. Add file types to restrict uploads to specific formats.",
    AllFiscalYearsAdded: "All fiscal years have been added",
    AllGood: "It's all good",
    AllListItemsUpToDate: "All list items are up to date",
    AllListsAdded: "All lists have been added",
    AllPromptsAdded: "All prompts have been added",
    AllResourcesPublished: "All resources were published successfully",
    AllRolesAdded: "All roles have been added",
    AllSetWrappingUp: "All set — wrapping up…",
    AllTeamsAdded: "All teams have already been added",
    AllToolsAdded: "All tools have been added",
    AllUsersAdded: "All users have already been added",
    AlreadyPopdockUsers: "{0} users were already Popdock users.",
    AndMore: "and {0} more",
    ApiUserNameAlreadyExists: "This API user name already exists",
    AppAlreadyQueued: "This app is already in the queue with the same target.",
    AppInstallsToAccount: "This app installs to your account.",
    AppNeedsConnector: "This app needs a connector you haven't added.",
    AppRegistrationNameExists: "An app registration with this name already exists",
    AppStoreDefinitionNoListsActionsOrLookups: "the app store definition contained no lists, actions or lookups",
    AppRequiresAppWithoutConnector: "This needs {0}, which uses a connector you haven't added.",
    AppRequiresUnavailableApp: "This needs an app that isn't available.",
    AppStoreDefinitionNoToolsOrPrompts: "the app store definition contained no tools or prompts",
    AppStoreNoApps: "No apps are available.",
    AppStoreNoMatchingApps: "No apps match '{0}'.",
    AppStoreQueueEmpty: "Pick an app, choose where it installs and add it to the queue. Everything in the queue installs together.",
    AppStoreQueueInstall: "Review the apps in the queue and install them.",
    AppStoreQueueNoApps: "No apps are queued yet. Add an app to the queue first.",
    AppStoreSelectApp: "Select an app to see what it does and choose where it installs.",
    AttachmentNameExists: "An attachment with this name already exists",
    AttachmentToolUnavailable: "The tool used for this attachment is no longer available. Nothing will be attached until you point it at an accessible tool.",
    AuthorizationFailed: "Authorization failed",
    AuthResponseHighlight: "The highlighted lines are the values Popdock reads. Nothing is highlighted when the path does not match the response.",
    AuthSummaryApiKey: "Popdock sends the stored key with every request. The credentials above decide the key's name and whether it travels as a URL parameter or a request header.",
    AuthSummaryBasic: "Popdock combines the stored user name and password and sends them with every request as an {0} header.",
    AuthSummaryBearerToken: "Popdock sends the stored token with every request as an {0} header.",
    AuthSummaryExchangeToken: "Popdock sends a {0} request to {1}, reads the token at {2} from the response, then sends that token with every request as an {3} header.",
    AuthSummaryExpiryAfterTime: " The token is replaced after {0} {1}.",
    AuthSummaryExpiryBeforeRequest: " A fresh token is fetched before every request.",
    AuthSummaryExpiryNever: " The token is kept and never refreshed.",
    AuthSummaryExpiryNotSet: " When the token expires is {0}.",
    AuthSummaryExpiryOnError: " A fresh token is fetched whenever a request is rejected.",
    AuthSummaryExpiryTokenPath: " How long the token lasts is read from {0} in the same response.",
    AuthSummaryNone: "Popdock sends no credentials, so the API has to allow the request unauthenticated.",
    AuthSummaryOAuth1: "Popdock signs every request with the stored OAuth 1.0 consumer key and token.",
    AuthSummaryOAuth2: "Popdock completes the OAuth 2.0 sign in once, then sends the access token with every request as an {0} header, refreshing it when it expires.",
    AuthSummaryUnknown: "Popdock sends the credentials above with every request, in the way {0} expects.",
    BackgroundActionSucceeded: "Your background action ran successfully",
    BilledMonthlyConfirmToSwitch: "You are billed monthly today. Confirm on your plan to switch.",
    BilledYearlyConfirmToSwitch: "You are billed yearly today. Confirm on your plan to switch.",
    BillingAccountUnavailable: "Your billing account could not be found. Contact support.",
    BillingAddressCheckFields: "Check these fields: {0}.",
    BillingAddressCouldNotBeLoaded: "The billing address could not be loaded. Please try again.",
    BillingAddressCouldNotBeSaved: "The billing address could not be saved. Please try again.",
    BillingAddressInvalid: "This billing address is not valid. Check it and try again.",
    BillingAddressInvalidFields: "Not a valid US address: {0}.",
    BillingAddressMissingFields: "Missing: {0}.",
    BillingAddressRejectedForTax: "Our payment provider could not use this billing address to work out sales tax. Check it in your account details, then try again.",
    BillingAddressRejectedForTaxHere: "Our payment provider could not use this billing address to work out sales tax. Check it and save again.",
    BillingAddressRequiredForTax: "A complete billing address is needed to work out sales tax on this purchase. Add one in your account details.",
    BillingAddressRequiredHere: "A complete billing address is needed to work out sales tax.",
    BillingCountryRequired: "Select your country in your account details before subscribing.",
    BillingPeriodChangesNextRenewal: "Your billing period changes at your next renewal.",
    BillingPortalCouldNotBeOpened: "The billing portal could not be opened. Please try again, or contact support if it keeps happening.",
    BlankKey: "Key cannot be blank",
    BlankName: "Name cannot be blank",
    BlankPrompt: "Prompt cannot be blank",
    BlankValue: "Value cannot be blank",
    Calculating: "Calculating....",
    CancelTakesEffectAtRenewal: "Cancellation takes effect at the end of the current billing period.",
    CannotDeleteTabWithWidgets: "You cannot delete a tab with widgets",
    CardCouldNotBeVerified: "We could not verify this card with your bank. Try again, or use a different card.",
    CardDetailsGoDirectlyToProvider: "Your card details are sent directly to our payment provider and are never stored by Popdock.",
    CardEntryUnavailable: "Adding a card is not available right now. Contact support if this continues.",
    CardVerificationHoldNotice: "To verify the card, your bank may show a small temporary authorization. It is released automatically and you will not be charged.",
    CardVerificationNotCompleted: "Card verification was not completed. Try again to finish adding this card.",
    CancelSubscriptionInBillingPortal: "Cancelling is finished in the billing portal, where you confirm it with your payment provider.",
    CantDeleteInUse: "This is being used by other resources and cannot be deleted.",
    CategoryNotSelected: "A category has not been selected",
    ChangeCouldNotBeSaved: "The change couldn't be saved. Please try again.",
    ChangesToPlanOnDate: "Changes to {0} on {1}.",
    ChangingSubscription: "Changing subscription...",
    CheckingForErrors: "Checking for errors...",
    ChooseCardToPayWith: "Choose a card to pay with.",
    ChoosePlanFitsTeam: "Choose the plan that fits your team. Change or cancel at any time.",
    ChoosePlanToKeepRunning: "Choose a plan to keep your connectors, lists and favorites running after {0}.",
    ChoosePlanToRestoreAccess: "Choose a plan to restore access.",
    CheckoutCouldNotBeCompleted: "Your checkout was not completed, so no subscription has been started.",
    CheckoutCouldNotBeStarted: "Checkout could not be started. Please try again.",
    ClearingFilters: "Clearing filters...",
    ClickAddAction: "Click here to add an action",
    ClickAddActions: "Click here to add actions",
    ClickAddApiUser: "Click here to add an API user",
    ClickAddApp: "Click here to add a new app",
    ClickAddCalculatedField: "Click here to add a calculated field",
    ClickAddCalculatedVariable: "Click here to add a calculated variable",
    ClickAddCalculation: "Click here to add a calculation",
    ClickAddColor: "Click here to add a color",
    ClickAddColors: "Click here to add colors",
    ClickAddColorCodingRule: "Click here to add a color coding rule",
    ClickAddColorGradient: "Click here to add a color gradient",
    ClickAddCompany: "Click here to add a {0}",
    ClickAddConnector: "Click here to add a connector",
    ClickAddConnectorDetails: "Click here to add connector details",
    ClickAddConnectorVariable: "Click here to add a connector variable",
    ClickAddCreditCard: "Click here to add a credit card",
    ClickAddCustomDetail: "Click here to add a custom detail",
    ClickAddCustomEntityCompare: "Click here to add a custom list that compares 2 lists",
    ClickAddCustomEntityJoin: "Click here to add a custom list that joins multiple lists",
    ClickAddCustomEntityMatrix: "Click here to add a matrix list",
    ClickAddCustomEntityMerge: "Click here to add a custom list that merges multiple lists",
    ClickAddCustomEntityRestriction: "Click here to add a custom list that restricts data in a list",
    ClickAddCustomEntitySummary: "Click here to add a custom list that summarizes data in a list",
    ClickAddDashboard: "Click here to add a dashboard",
    ClickAddDefaultColumn: "Click here to add default columns",
    ClickAddDefaultField: "Click here to add default fields",
    ClickAddDefaultsToFields: "Click here to add existing default fields",
    ClickAddDependency: "Click here to add a dependency",
    ClickAddDetail: "Click here to add a detail",
    ClickAddDomainRestriction: "Click here to add a domain restriction",
    ClickAddEndpoint: "Click here to add an endpoint",
    ClickAddEntities: "Click here to add lists",
    ClickAddEntity: "Click here to add a list",
    ClickAddEntityQueryBuilder: "Click here to add a new list with the query builder",
    ClickAddEnvironmentParam: "Click here to add an environment parameter",
    ClickAddFavorite: "Click here to add a favorite",
    ClickAddField: "Click here to add a field",
    ClickAddFieldSample: "Click here to add fields from a sample query or file",
    ClickAddFields: "Click here to add fields",
    ClickAddFileSplit: "Click here to add a file split",
    ClickAddFilter: "Click here to add a filter",
    ClickAddFilterVariable: "Click here to add a filter variable",
    ClickAddFiscalPeriod: "Click here to add a single fiscal period",
    ClickAddFiscalPeriodRange: "Click here to generate a range of fiscal periods",
    ClickAddFiscalYear: "Click here to add a fiscal year",
    ClickAddFlow: "Click here to add a flow",
    ClickAddFormBodyField: "Click here to add a form body field",
    ClickAddGlobalVariable: "Click here to add a global variable",
    ClickAddGroup: "Click here to add a group",
    ClickAddGroupField: "Click here to add a group field",
    ClickAddHeader: "Click here to add a header",
    ClickAddInsight: "Click here to add an insight",
    ClickAddIpAddress: "Click here to add an IP address",
    ClickAddItem: "Click here to add a new item",
    ClickAddItemToForm: "Click here to add an item to the form",
    ClickAddJob: "Click here to add a scheduled job",
    ClickAddJoin: "Click here to add a join",
    ClickAddKeyField: "Click here to add a key field",
    ClickAddListItem: "Click here to add a list item",
    ClickAddLookup: "Click here to add a lookup",
    ClickAddMatchingFields: "Click here to add matching fields",
    ClickAddMultipleListItems: "Click here to add multiple list items",
    ClickAddOptimization: "Click here to add an optimization",
    ClickAddPage: "Click here to add a page",
    ClickAddParameter: "Click here to add a parameter",
    ClickAddPartnerUser: "Click here to grant access to a partner user",
    ClickAddPlaceholderUser: "Click here to grant access to a {0} user",
    ClickAddRelationship: "Click here to add a relationship",
    ClickAddReportingTree: "Click here to add a reporting tree",
    ClickAddResource: "Click here to add a resource",
    ClickAddRestriction: "Click here to add a restriction",
    ClickAddRetryStatusCodes: "Click here to add a retry status code",
    ClickAddRole: "Click here to add a role",
    ClickAddRule: "Click here to add a rule",
    ClickAddSandbox: "Click here to add a sandbox",
    ClickAddSidebar: "Click here to add a sidebar",
    ClickAddSort: "Click here to add a sort",
    ClickAddSummaryFields: "Click here to add summary fields",
    ClickAddSupportUser: "Click here to temporarily grant access to a support user",
    ClickAddTab: "Click here to add a tab",
    ClickAddTable: "Click here to add a table",
    ClickAddTag: "Click here to add a tag",
    ClickAddTeam: "Click here to add a team",
    ClickAddToken: "Click here to add a token",
    ClickAddUser: "Click here to add a user",
    ClickAddUserVariable: "Click here to add a user variable",
    ClickAddVirtualNetwork: "Click here to add a virtual network",
    ClickAddWidget: "Click here to add a widget",
    ClickAssignUser: "Click here to assign a user",
    ClickCopyListItems: "Click here to copy list items",
    ClickCustomizeHomePage: "Click here to customize your home page with favorites, summaries and quick links",
    ClickDisplayPreview: "Click here to display a preview",
    ClickEditFilter: "Click to edit filter settings.",
    ClickEditScript: "Click here to edit the script",
    ClickImportFiscalYears: "Click here to import fiscal years from a connector",
    ClickResubscribe: "Click here to resubscribe",
    ClickSelectRoles: "Click here to select roles",
    ClickSelectTeams: "Click here to select teams",
    ClickShareFavoriteTeam: "Click here to share this favorite with a team",
    ClickShareFavoriteUser: "Click here to share this favorite with a user",
    ClickSort: "Click to sort by this column",
    ClickSortAscending: "Click to sort in ascending order",
    ClickSortDescending: "Click to sort in descending order",
    ClickSubscribe: "Click here to subscribe",
    ClickUpdateSubscription: "Click here to update your subscription",
    ClickViewImage: "Click here to view image",
    ClientSecretNeededForAuthorizationCode: "This app needs a client secret to exchange an authorization code.",
    ColorNameExists: "A color with this name already exists",
    ColorPaletteNameExists: "A color palette with this name already exists",
    ColumnNameExists: "A column with this name already exists",
    CompanyNotSelected: "A company has not been selected",
    ComponentNameExists: "A component with this name already exists",
    ConfirmChangeToDynamicListItems: "Changing to dynamic list items will delete your existing list items. Are you sure you want to proceed?",
    ConfirmClearFilters: "Are you sure you want to clear all filters?",
    ConfirmDeactivateUser: "Are you sure you want to deactivate this user?",
    ConfirmDeactivateWidget: "Are you sure you want to unpublish this widget?",
    ConfirmDeleteAction: "Are you sure you want to delete this action?",
    ConfirmDeleteAdaptiveCard: "Are you sure you want to delete this adaptive card?",
    ConfirmDeleteAdaptiveCardTemplate: "Are you sure you want to delete this adaptive card template?",
    ConfirmDeleteAiDataSource: "Are you sure you want to delete this knowledge base?",
    ConfirmDeleteAiModel: "Are you sure you want to delete this AI model?",
    ConfirmDeleteAiToneModifier: "Are you sure you want to delete this AI tone modifier?",
    ConfirmDeleteAiTool: "Are you sure you want to delete this AI tool?",
    ConfirmDeleteAllowedFileType: "Are you sure you want to delete this allowed file type?",
    ConfirmDeleteApp: "Are you sure you want to delete this app?",
    ConfirmDeleteAppRegistration: "Are you sure you want to delete this app registration?",
    ConfirmDeleteAttachment: "Are you sure you want to delete this attachment?",
    ConfirmDeleteBlock: "Are you sure you want to delete this block?",
    ConfirmDeleteBranch: "Are you sure you want to delete this branch? All child tasks of the branch will also be deleted.",
    ConfirmDeleteCell: "Are you sure you want to delete this cell?",
    ConfirmDeleteClient: "Are you sure you want to delete this client?",
    ConfirmDeleteClientInstruction: "Are you sure you want to delete this client instruction?",
    ConfirmDeleteClientMapping: "Are you sure you want to delete this client mapping?",
    ConfirmDeleteColor: "Are you sure you want to delete this color?",
    ConfirmDeleteColorCoding: "Are you sure you want to delete this color coding rule?",
    ConfirmDeleteColorGradient: "Are you sure you want to delete this color gradient?",
    ConfirmDeleteColorPalette: "Are you sure you want to delete this color palette?",
    ConfirmDeleteColumn: "Are you sure you want to delete this column?",
    ConfirmDeleteColumnAndFields: "Are you sure you want to remove this column and all of it's fields?",
    ConfirmDeleteCompany: "Are you sure you want to delete this {0}?",
    ConfirmDeleteCompanyDefault: "Are you sure you want to delete this company?",
    ConfirmDeleteComponent: "Are you sure you want to delete this component?",
    ConfirmDeleteConnector: "Are you sure you want to delete this connector?",
    ConfirmDeleteDashboard: "Are you sure you want to delete this dashboard?",
    ConfirmDeleteDataSource: "Are you sure you want to delete this data source?",
    ConfirmDeleteDateFilter: "Are you sure you want to delete this date filter?",
    ConfirmDeleteDefaultField: "Are you sure you want to remove this field from the default view?",
    ConfirmDeleteDependency: "Are you sure you want to remove this dependency?",
    ConfirmDeleteDetail: "Are you sure you want to delete this detail?",
    ConfirmDeleteDomain: "Are you sure you want to delete this domain?",
    ConfirmDeleteElement: "Are you sure you want to delete this element?",
    ConfirmDeleteEmailSignature: "Are you sure you want to delete this email signature?",
    ConfirmDeleteEmailTemplate: "Are you sure you want to delete this email template?",
    ConfirmDeleteEndpoint: "Are you sure you want to delete this endpoint?",
    ConfirmDeleteEntity: "Are you sure you want to delete this list?",
    ConfirmDeleteErrorCode: "Are you sure you want to delete this error code",
    ConfirmDeleteExcelTemplate: "Are you sure you want to delete this Excel template?",
    ConfirmDeleteFastTab: "Are you sure you want to delete this Fast Tab extension?",
    ConfirmDeleteFavorite: "Are you sure you want to delete this favorite?",
    ConfirmDeleteField: "Are you sure you want to delete this field?",
    ConfirmDeleteFile: "Are you sure you want to delete this file?",
    ConfirmDeleteFileSplit: "Are you sure you want to delete this file split?",
    ConfirmDeleteFilter: "Are you sure you want to delete this filter?",
    ConfirmDeleteFilterVariable: "Are you sure you want to delete this filter variable?",
    ConfirmDeleteFirewall: "Are you sure you want to delete this firewall?",
    ConfirmDeleteFiscalPeriod: "Are you sure you want to delete this fiscal period?",
    ConfirmDeleteFiscalYear: "Are you sure you want to delete this fiscal year?",
    ConfirmDeleteFlow: "Are you sure you want to delete this flow?",
    ConfirmDeleteForm: "Are you sure you want to delete this form?",
    ConfirmDeleteGlobal: "Are you sure you want to delete this global variable?",
    ConfirmDeleteGroup: "Are you sure you want to delete this group?",
    ConfirmDeleteHeader: "Are you sure you want to delete this header?",
    ConfirmDeleteHubspotCard: "Are you sure you want to delete this HubSpot card?",
    ConfirmDeleteIcon: "Are you sure you want to delete this icon?",
    ConfirmDeleteImage: "Are you sure you want to delete this image?",
    ConfirmDeleteIntegration: "Are you sure you want to delete this integration?",
    ConfirmDeleteIpAddress: "Are you sure you want to delete this IP address?",
    ConfirmDeleteItem: "Are you sure you want to delete this item?",
    ConfirmDeleteJob: "Are you sure you want to delete this job?",
    ConfirmDeleteJoin: "Are you sure you want to delete this join?",
    ConfirmDeleteJoinedList: "Are you sure you want to delete this joined list?",
    ConfirmDeleteKeyField: "Are you sure you want to delete this key field?",
    ConfirmDeleteListAction: "Are you sure you want to delete this list action?",
    ConfirmDeleteListItem: "Are you sure you want to delete this list item?",
    ConfirmDeleteLookup: "Are you sure you want to delete this lookup?",
    ConfirmDeleteLoop: "Are you sure you want to delete this loop? All tasks within the loop will also be deleted.",
    ConfirmDeleteMapping: "Are you sure you want to delete this mapping?",
    ConfirmDeleteMatchingFields: "Are you sure you want to delete these matching fields?",
    ConfirmDeleteMcpClient: "Are you sure you want to delete this MCP client?",
    ConfirmDeleteMcpServer: "Are you sure you want to delete this MCP server?",
    ConfirmDeleteMcpTool: "Are you sure you want to delete this MCP tool?",
    ConfirmDeleteMessage: "Are you sure you want to delete this message?",
    ConfirmDeleteMessagingTemplate: "Are you sure you want to delete this messaging template?",
    ConfirmDeleteMobileApp: "Are you sure you want to delete this mobile app?",
    ConfirmDeleteNotificationRecipient: "Are you sure you want to delete this recipient?",
    ConfirmDeleteOptimization: "Are you sure you want to delete this optimization?",
    ConfirmDeletePage: "Are you sure you want to delete this page?",
    ConfirmDeleteParameter: "Are you sure you want to delete this parameter?",
    ConfirmDeletePdfTemplate: "Are you sure you want to delete this PDF template?",
    ConfirmDeletePrompt: "Are you sure you want to delete this prompt?",
    ConfirmDeleteQuery: "Are you sure you want to delete this query?",
    ConfirmDeleteRedactionMethod: "Are you sure you want to delete this redaction method?",
    ConfirmDeleteRedirectUri: "Are you sure you want to delete this redirect URI?",
    ConfirmDeleteRelationship: "Are you sure you want to delete this relationship?",
    ConfirmDeleteReport: "Are you sure you want to delete this report?",
    ConfirmDeleteResource: "Are you sure you want to delete this resource?",
    ConfirmDeleteResponseField: "Are you sure you want to delete this response field?",
    ConfirmDeleteRestriction: "Are you sure you want to delete this restriction?",
    ConfirmDeleteReturnField: "Are you sure you want to delete this return field?",
    ConfirmDeleteRole: "Are you sure you want to delete this role?",
    ConfirmDeleteRow: "Are you sure you want to delete this row?",
    ConfirmDeleteRule: "Are you sure you want to delete this rule?",
    ConfirmDeleteSandbox: "Are you sure you want to delete this sandbox?",
    ConfirmDeleteSection: "Are you sure you want to delete this section?",
    ConfirmDeleteSidebar: "Are you sure you want to delete this group widget?",
    ConfirmDeleteSort: "Are you sure you want to delete this sort?",
    ConfirmDeleteStyle: "Are you sure you want to delete this style?",
    ConfirmDeleteSvgCard: "Are you sure you want to delete this SVG card?",
    ConfirmDeleteTab: "Are you sure you want to delete this tab?",
    ConfirmDeleteTable: "Are you sure you want to delete this table?",
    ConfirmDeleteTag: "Are you sure you want to delete this tag?",
    ConfirmDeleteTask: "Are you sure you want to delete this task?",
    ConfirmDeleteTeam: "Are you sure you want to delete this team?",
    ConfirmDeleteTextFormat: "Are you sure you want to remove this text format?",
    ConfirmDeleteTheme: "Are you sure you want to delete this theme?",
    ConfirmDeleteTile: "Are you sure you want to delete this tile",
    ConfirmDeleteToken: "Are you sure you want to delete this token?",
    ConfirmDeleteTool: "Are you sure you want to delete this tool?",
    ConfirmDeleteTreeItem: "Are you sure you want to delete this tree item?",
    ConfirmDeleteUser: "Are you sure you want to delete this user?",
    ConfirmDeleteUserInput: "Are you sure you want to delete this user input?",
    ConfirmDeleteValidationRule: "Are you sure you want to delete this validation rule?",
    ConfirmDeleteVariable: "Are you sure you want to delete this variable?",
    ConfirmDeleteVariant: "Are you sure you want to delete this variant?",
    ConfirmDeleteVirtualNetwork: "Are you sure you want to delete this virtual network?",
    ConfirmDeleteVisualforcePage: "Are you sure you want to delete this Visualforce page?",
    ConfirmDeleteWidget: "Are you sure you want to delete this widget?",
    ConfirmDeleteWorksheet: "Are you sure you want to delete this worksheet?",
    ConfirmPublishExtensionProduction: "Are you sure you want to publish this extension to your production environment?",
    ConfirmPublishVersion: "Publish this version? It will become the live version and the currently published version will be archived.",
    ConfirmPublishWidget: "Are you sure you want to publish this widget?",
    ConfirmRemoveAction: "Are you sure you want to remove this action?",
    ConfirmRemoveConnector: "Are you sure you want to remove this connector?",
    ConfirmRemoveCustomScript: "Are you sure you want to remove your custom script? All added fields will be removed.",
    ConfirmRemoveEntity: "Are you sure you want to remove this list?",
    ConfirmRemoveEntitySecurity: "Are you sure you want to remove security to this list?",
    ConfirmRemoveItem: "Are you sure you want to remove this item?",
    ConfirmRemoveMcpClient: "Are you sure you want to remove this MCP client?",
    ConfirmRemoveProfilePicture: "Are you sure you want to remove your profile picture?",
    ConfirmRemoveTeam: "Are you sure you want to remove this team?",
    ConfirmRemoveTeamMember: "Are you sure you want to remove this team member?",
    ConfirmRemoveUser: "Are you sure you want to remove this user?",
    ConfirmRemoveUserFromRole: "Are you sure you want to remove this user from this role?",
    ConfirmRemoveUserFromTeam: "Are you sure you want to remove this user from this team?",
    ConfirmRemoveWidgetFromApp: "Are you sure you want to remove this widget from this app?",
    ConfirmReuploadEntity: "Are you sure you want to re-upload this list?",
    ConfirmRollBackVersion: "Roll back to this version? It will become the live version and the currently published version will be archived.",
    ConfirmStopSharingFavorite: "Are you sure you want to stop sharing this favorite?",
    ConfirmSwitchAuthentication: "Switching authentication will disconnect every user connected to this connector. They'll each need to reconnect before they can use it again.",
    ConfirmUnsubscribe: "Are you sure you want to unsubscribe from Popdock?",
    ConfirmUpdateDependencyVersion: "Are you sure that you want to change this dependency from {0} to version {1} to match your environment?",
    Connecting: "Connecting...",
    ConnectionFailed: "Connection failed",
    ConnectionWasSuccessfullyValidated: "The connection was successfully validated",
    ConnectorAuthErrorAccessDenied: "Access denied",
    ConnectorAuthErrorContentReadError: "Response could not be read",
    ConnectorAuthErrorCreateFailed: "The connector could not be created",
    ConnectorAuthErrorEmptyPlaceholder: "Empty placeholder",
    ConnectorAuthErrorHttpError: "HTTP error",
    ConnectorAuthErrorHttpSendError: "HTTP request failed",
    ConnectorAuthErrorInvalidClient: "Invalid client credentials",
    ConnectorAuthErrorInvalidConfiguration: "Invalid configuration",
    ConnectorAuthErrorInvalidFieldValue: "Invalid field value",
    ConnectorAuthErrorInvalidGrant: "Invalid or expired grant",
    ConnectorAuthErrorInvalidJsonPath: "Invalid JSON path",
    ConnectorAuthErrorInvalidJsonResponse: "Invalid JSON response",
    ConnectorAuthErrorInvalidParameter: "Invalid parameter",
    ConnectorAuthErrorInvalidRegex: "Invalid regular expression",
    ConnectorAuthErrorInvalidRequest: "Invalid request",
    ConnectorAuthErrorInvalidResponse: "Invalid response",
    ConnectorAuthErrorInvalidResponsePath: "Invalid response path",
    ConnectorAuthErrorInvalidScheme: "Invalid URI scheme",
    ConnectorAuthErrorInvalidScope: "Invalid scope",
    ConnectorAuthErrorInvalidServiceAccountJson: "Invalid service account JSON",
    ConnectorAuthErrorInvalidState: "Invalid state",
    ConnectorAuthErrorInvalidUri: "Invalid URI",
    ConnectorAuthErrorJwtCreationError: "JWT creation failed",
    ConnectorAuthErrorMissingPlaceholder: "Missing placeholder",
    ConnectorAuthErrorMissingRefreshToken: "No refresh token returned",
    ConnectorAuthErrorMissingRequiredField: "Missing required field",
    ConnectorAuthErrorMissingState: "Missing state",
    ConnectorAuthErrorReauthRequired: "Reauthorization required",
    ConnectorAuthErrorRefreshFailed: "Token refresh failed",
    ConnectorAuthErrorServerError: "Service error",
    ConnectorAuthErrorSessionError: "Session error",
    ConnectorAuthErrorSessionExpired: "Session expired",
    ConnectorAuthErrorTemporarilyUnavailable: "Service temporarily unavailable",
    ConnectorAuthErrorTokenExchangeFailed: "Token exchange failed",
    ConnectorAuthErrorUnauthorizedClient: "Client is not authorized",
    ConnectorAuthErrorUnknownError: "Unknown error",
    ConnectorAuthErrorUnsupportedGrantType: "Unsupported grant type",
    ConnectorAuthErrorValidationFailed: "Validation failed",
    ConnectorInstalledInFinalStep: "Popdock installs your {0} connection in the final step. You can add a get-data tool from the connector once it's ready.",
    ConnectorNeedsSettingsAfterSignIn: "This connector asks for more settings after you sign in, which setup can't collect yet. Add it from the Connectors page instead.",
    ConnectorNoLongerAvailableRetry: "The connector this build started is no longer available. Try again to install it fresh.",
    ConnectorNotInstalledForGetDataTool: "The connector was not installed, so the get-data tool could not be created.",
    ConnectorUnexpectedResponse: "The connector returned an unexpected response.",
    CopyFormSnippetDescription: "Paste the embed code into your host app or portal.",
    CopyMcpServerUrlDescription: "Paste into Claude, Cursor, or any MCP client.",
    CouldNotLoadListsFromConnector: "Couldn't load lists from {0}. Go back and reconnect, then try again.",
    CouldNotLoadTablesFromConnector: "Couldn't load tables from {0}. Check the connection and try again.",
    CouldNotBeImported: "could not be imported",
    CouldNotVerifyInstalledLists: "Couldn't check the installed lists. Try again.",
    CouponApplied: "Coupon applied",
    CouponCouldNotBeChecked: "This coupon could not be checked. Please try again.",
    CouponDoesNotApplyToPlan: "This coupon cannot be used with the plan you have selected.",
    CouponHasNoEffect: "This coupon did not change the price of this purchase.",
    ConnectorLoginFailed: "Login failed or was cancelled",
    ConnectorNameExists: "A connector with this name already exists",
    ConnectorNotUsedDetails: "This connector has not been used for any details",
    ConnectorNotUsedEntities: "This connector has not been used for any lists",
    ConnectorNotUsedWidgets: "This connector has not been used for any widgets",
    ConnectorRequiresSubscription: "This connector requires a subscription that your account does not have enabled.",
    ConnectorSetupFailed: "Connector setup failed",
    ConnectorUpToDate: "This connector is up to date",
    CopyClientSecretNow: "Copy this client secret now. It is not stored anywhere you can read it back — no part of Popdock can show it to you again. If you lose it, revoke the secret and add a new one.",
    CouldNotDeleteTryAgain: "This could not be deleted. Please try again, and contact support if the problem continues.",
    CouldNotLoadIntacctConnectorsCheck: "Could not load Intacct connectors. Check the Sage gateway configuration and try again.",
    CouponIsNotValid: "This coupon code is not valid for this purchase.",
    CreatedDuringPopdockOnboarding: "Created during Popdock onboarding",
    CreditCardFailed: "Your credit card has expired or was rejected",
    CreditCardFailedContactAdmin: "Your connectors and favorites are still here. Contact your account administrator to update it.",
    CreditCardFailedUpdateCard: "Your connectors and favorites are still here. Update your card to turn them back on.",
    CustomActionInvalidSubscription: "Custom actions are only available for Business subscriptions and above",
    CustomEntityInvalidSubscription: "Custom lists are only available for Business subscriptions and above",
    DataAccessPausedChoosePlan: "Data access is paused. Choose a plan to restore your connectors. Nothing has been deleted.",
    DebugMode: "Run in debug mode",
    DefaultScriptUsedForEntity: "The default script is being used for this list",
    DetailNameExists: "A detail with this name already exists",
    DetailNoFields: "There are no fields for this detail",
    DetailNotSelected: "A detail has not been selected",
    DoNotHaveAnyFavoritesImport: "You do not have any favorites to import",
    DoNotHaveAnyFieldsCan: "You do not have any fields that can be used to sort the results",
    DoNotHaveAnyResourcesPublish: "You do not have any resources to publish",
    DownloadFailed: "Failed to download",
    DownloadBlocked: "Your browser or host blocked the download. Use the link below to open your file in a new tab.",
    Downloading: "Downloading...",
    DragDropFileHereUpload: "Drag and drop your file here to upload",
    DropJsonFileHere: "Drop a JSON file here",
    DuplicateListItemsNotAllowed: "Duplicate list items are not allowed",
    DuplicatingAction: "Duplicating action...",
    DuplicatingEntity: "Duplicating list...",
    EditAddOnsOrSwitchPeriod: "Edit add-ons or switch billing period to continue",
    EmailSent: "Your email has been sent. We will review your issue and get back to you as soon as possible.",
    EndpointNameExists: "An endpoint with this name already exists",
    EndpointParameterNameExists: "An endpoint parameter with this name already exists",
    EndpointValueAlreadyExists: "An endpoint with this value already exists",
    EnterPartnerCode: "If you have a partner code, please enter it here",
    EnterPromoCode: "If you have a promo code, please enter it here",
    EntityHidden: "List is hidden from end users",
    EntityPublishedSuccessfully: "Your list was successfully published",
    EntityRemoved: "This list has been removed",
    ErrorHandlingAnyError: "any error",
    ErrorHandlingNoRetry: "When a request fails, Popdock reports the error straight away and does not send it again.",
    ErrorHandlingRetry: "When a request returns {0}, Popdock waits {1} milliseconds and sends it again, up to {2} times.",
    ErrorHandlingRetryNone: "Retrying is on, but the maximum number of retries is zero, so a failed request is reported straight away.",
    ErrorHandlingRetryOnce: "When a request returns {0}, Popdock waits {1} milliseconds and sends it again once.",
    ErrorHandlingTimelineCaption: "A status code that is not on the list fails on the first attempt.",
    ErrorHandlingTimelineRetry: "Retry {0} of {1}",
    ErrorHandlingTimelineWait: "Wait {0} milliseconds",
    ErrorLoadingFields: "There was an error while loading fields",
    ErrorRunningAction: "An error occurred while running the action",
    ErrorUnsubscribing: "An error occurred while trying to unsubscribe. Please try again later.",
    EverythingInPlan: "Everything in {0}",
    ExcelTemplateNameExists: "An Excel template with this name already exists",
    ExpiresInMilisecs: "Expires in (milliseconds)",
    ExpiresInMins: "Expires in (minutes)",
    ExpiresInSecs: "Expires in (seconds)",
    ExpiresOnDateTime: "Expires on date (date time)",
    ExpiresOnDateUnixMilisecs: "Expires on date (UNIX milliseconds)",
    ExpiresOnDateUnixSecs: "Expires on date (UNIX seconds)",
    Exporting: "Exporting...",
    ExtensionHasBeenSuccessfullyPublished: "Your extension has been successfully published",
    ExtensionMustBePublishedToSandbox: "You must create an extension using a sandbox connector before you can publish",
    ExtensionPublishedSuccessfully: "Your extension was published successfully",
    FailedAddAppRegistration: "Failed to add the app registration.",
    FailedAddClientSecret: "Failed to add the client secret.",
    FavoriteNameExists: "A favorite with this name already exists",
    FavoriteNameExists2: "An favorite with this name already exists",
    FavoriteNotSharedWithTeams: "This favorite is not shared with any teams",
    FavoriteNotSharedWithUsers: "This favorite is not shared with any users",
    FavoriteNotUsedRecently: "This favorite has not been recently used by any users",
    FavoriteNotUsedWidget: "This favorite is not used on any widgets",
    FavoritePromptNameExists: "A favorite prompt with this name already exists",
    FavoriteSearchPlaceholder: "Enter the name of a favorite or list",
    FeatureRequiresSubscription: "This feature requires a subscription that your account does not have enabled.",
    FieldNameExists: "A field with this name already exists",
    FieldPathsRelativeToRootPath: "Field paths are relative to the root path '{0}'.",
    FieldsNotSortedForDetail: "Fields are not sorted for this detail",
    FileNotValid: "This file is not valid",
    FileTypeExists: "This file type already exists",
    FilenameAlreadyUsedByEntity: "This filename is already in use by another list",
    Filtering: "Filtering...",
    Finished: "Finished",
    FiscalYearNameExists: "A fiscal year with this name already exists",
    FormTemplateCaptureDescription: "Minimal form (name, email, note), ideal for marketing or support pages.",
    FormTemplateCreateDescription: "Submit a new record (customer, lead, ticket) into your system.",
    FormTemplateUpdateDescription: "Find an existing record and edit fields users are allowed to change.",
    FormTemplateWizardDescription: "Wizard-style form that walks users through a longer submission.",
    GeneratingColumns: "Generating columns...",
    GeneratingFile: "Generating file...",
    GeneratingPreview: "Generating preview...",
    GettingDashboards: "Getting dashboards...",
    GettingRoles: "Getting roles...",
    GettingTeamMembers: "Getting team members...",
    GettingTeams: "Getting teams...",
    GettingUsers: "Getting users...",
    GettingWidgets: "Getting widgets...",
    GoBackAndConnectToChooseList: "Go back and connect {0} to choose the list to email.",
    GoConnectorDescription: "Open the connector to edit credentials, entities, and lists.",
    GoMcpServerDescription: "Open the server in Popdock to edit tools, prompts, and security.",
    GoMigrationConnectorDescription: "Open the modern ERP to add more lists or actions.",
    GoalAiSummariesDescription: "Have AI summarize your data on a schedule and deliver to email, Teams, or Slack.",
    GoalEmbedDescription: "Drop live tables, lists, and search into another app or portal with a code snippet.",
    GoalEmbedFormDescription: "Drop a form into another app so users can submit data straight into your business system.",
    GoalLegacyMigrationDescription: "One-time migration from Dynamics GP, SL, NAV, or SQL Server into Azure Data Lake or Amazon S3.",
    GoalMcpDescription: "Expose your data as MCP tools so Claude, ChatGPT, and other AI clients can query it directly.",
    GoalQueryDescription: "Search and pivot across systems, save favorites, and export to Excel or PDF on demand.",
    GoalScheduledEmailDescription: "Email an Excel, CSV, or Markdown file of your data to a recipient list on a schedule.",
    GoodToGo: "You are all good to go!",
    GroupNameExists: "A group with this name already exists",
    HaveNotAddedAnyElements: "You have not added any elements",
    HaveNotAddedAnyElementsSection: "You have not added any elements to this section",
    HaveNotAddedAnySections: "You have not added any sections",
    HaveNotRunCalculationQuery: "You have not run the calculation query",
    HaveNotSelectedAnyFieldsDefault: "You have not selected any fields. The default fields will be used for this endpoint.",
    HeaderKeyExists: "A header with this key already exists",
    IconNameExists: "An icon with this name already exists",
    ImportFailed: "The import failed.",
    ImportFiscalYears: "Import fiscal years from a connector",
    Importing: "Importing...",
    ImportingFavorites: "Importing favorites...",
    IncludedInThisPlan: "Included in this plan",
    InspectMigratedTablesDescription: "See what's landed in your destination.",
    InstallFailed: "Install failed.",
    InstallTakingLongerThanExpected: "The install is taking longer than expected. Try again, or check the connector from the Connectors page.",
    InstallingConnectors: "Please wait while we install your connectors",
    InvalidIpAddress: "IP address must be a valid IPv4 address",
    InvalidJsonError: "JSON must be an object or array",
    InvalidPartnerCode: "The partner code entered was not valid.",
    InvalidValue: "This value is invalid",
    InviteEmailsTooltip: "Separate multiple addresses with spaces, commas, semicolons, or new lines.",
    InviteFailedForAddress: "{0} couldn't be invited: {1}",
    InvitesCouldNotBeSent: "The invites couldn't be sent. Try again, or clear the email field to continue without inviting.",
    InvitesCouldNotBeSentSomeAddresses: "Some invites couldn't be sent. Fix the addresses below, or clear the email field to continue without inviting.",
    InvoicePdfUnavailable: "This invoice could not be downloaded as a PDF. Please try again later.",
    InvoicePdfsUnavailable: "The invoices could not be downloaded. Please try again later.",
    IssuesFoundComparingEntities: "Issues were found when comparing the following lists to your production environment:",
    ItemDeletedOrDoesntExist: "Whatever you were looking for appears to have been moved, deleted or does not exist.",
    JobHasRunHistory: "This job has run history and cannot be deleted",
    JobNameExists: "A job with this name already exists",
    LearnPopdock: "Learn how to configure and use Popdock.",
    LearnPopdockScript: "Learn how to write calculated fields using Popdock's built-in scripting language.",
    LeastOneGrantTypeMustEnabled: "At least one grant type must be enabled.",
    ListItemAlreadyExists: "This list item already exists",
    ListNameExists: "A list with this name already exists",
    ListNotAvailableForScheduledEmail: "The {0} list isn't available on your connector, so the email couldn't be scheduled. You can create it from the Scheduler page once the list is added.",
    Loading: "Loading...",
    LoadingColors: "Loading colors...",
    LoadingEntities: "Loading lists...",
    LoadingFavorite: "Loading favorite...",
    LoadingFields: "Loading fields...",
    LoadingFiscalYears: "Loading fiscal years...",
    LoadingSmartConnectErrorId: "Loading smart connect error Id's...",
    LoadingSmartConnectErrorFields: "Loading smart connect error fields...",
    LoadingTables: "Loading tables...",
    LoadingUsers: "Loading users...",
    LoadingYourConnectors: "Loading your connectors. This will only take a moment.",
    LoginInstructions: "You have selected the following applications. You will need to log in to these applications to authorize Popdock to access them.",
    LookupNameExists: "A lookup with this name already exists",
    MajorVersionsDontMatch: "Major versions don't match",
    ManageRecipientsDescription: "Add or remove people, change the schedule, or pick a different list.",
    MapIntacctGroupsPopdockTeams: "Map Intacct groups to Popdock teams.",
    MapIntacctUsersPopdockUsers: "Map Intacct users to Popdock users.",
    MaximumAppRegistrationRedirectUris: "An app may have at most {0} redirect URIs.",
    MaximumAppRegistrationSecrets: "An app may have at most {0} active secrets. Revoke one first.",
    MaximumRecords: "Maximum records reached.",
    MaximumTokens: "Maximum number of tokens has been assigned",
    McpClientNameExists: "An MCP client with this name already exists",
    McpServerCreatedFromAppStore: "Created from the app store.",
    McpServerDefaultDescription: "Provides access to {0} data for AI clients including Claude, ChatGPT, and Cursor.",
    McpServerDescriptionPlaceholder: "What this server is for, e.g. \"Read-only access to {0} for AI assistants.\"",
    McpServerDescriptionTooltip: "A short summary AI clients can use to understand what this server is for.",
    McpServerNameExists: "A MCP server with this name already exists",
    McpServerNameTooltip: "Auto-generated from your connector name. This is what AI clients will see when listing your servers.",
    McpServerNamesCannotStartNumber: "MCP server names cannot start with a number",
    McpServerNotCreated: "The MCP server was not created, so its tools and prompts could not be added.",
    McpToolDescriptionTooltip: "Describe what this tool returns so AI clients know when to call it.",
    McpToolMaxRecordsTooltip: "Caps how many records the AI can fetch per call.",
    McpToolNameTooltip: "The identifier AI clients use to call this tool. Lowercase, no spaces.",
    MergeListCustomersDescription: "Blend legacy and modern customer records into one searchable list.",
    MergeListInvoicesDescription: "Full AR history across both ledgers.",
    MergeListItemsDescription: "Combined item catalog from legacy and modern ERP.",
    MergeListSalesOrdersDescription: "Historical and current sales orders side-by-side.",
    MergeListVendorsDescription: "Unified vendor list across both systems.",
    MfaAuthenticatorAppRequired: "You must have at least one authenticator app selected",
    MinorVersionsDontMatch: "Minor versions don't match",
    MissingConnectionDetails: "Missing connection details. Go back and reconnect this connector.",
    MissingExtension: "Extension with matching name and publisher not found",
    MissingFieldPlaceholder: "Missing field: {0}",
    MissingRequiredFields: "Not all required fields are entered",
    MissingTablePlaceholder: "Missing table: {0}",
    MobileAppNameExists: "A mobile app with this name already exists",
    ModelNameExists: "A model with this name already exists",
    MustSelectCompany: "You must select a company",
    NameExists: "This name already exists",
    NewPlanStartsNextRenewal: "Your new plan starts at the next renewal.",
    NoAccessActionsTeam: "This team does not have any access to any actions",
    NoAccessActionsUser: "This user does not have any access to any actions",
    NoAccessCompaniesTeam: "This team does not have any access to any companies",
    NoAccessCompaniesUser: "This user does not have any access to any companies",
    NoAccessConnectorsTeam: "This team does not have access to any connectors",
    NoAccessConnectorsUser: "This user does not have access to any connectors",
    NoAccessEntitiesTeam: "This team does not have any access to any lists",
    NoAccessEntitiesUser: "This user does not have any access to any lists",
    NoAccessMcpServersTeam: "This team does not have access to any MCP servers",
    NoAccessMcpServersUser: "This user does not have access to any MCP servers",
    NoActionHiddenFields: "You do not have any hidden fields on this action",
    NoActions: "There are no actions",
    NoActionsAdded: "You have not added any actions",
    NoActionsForConnector: "There are no actions for this connector",
    NoActionsForEntity: "You have not added any actions to this list",
    NoActionsRunInThisPeriod: "There were no actions run in this period",
    NoActiveConnectors: "There are no active connectors",
    NoAdaptiveCardTemplatesAdded: "You have not added any adaptive card templates",
    NoAddedCalculations: "You have not added any calculations",
    NoAiToneModifiersAdded: "You have not added any AI tone modifiers",
    NoApiUsersSecurity: "You have not added any API users",
    NoAppRegistrationsAdded: "You have not added any app registrations",
    NoApps: "You have not added any apps",
    NoAttachmentsAdded: "You have not added any attachments",
    NoAttachmentsForTool: "You have not added any attachments to this tool",
    NoBaseEntity: "You have not selected a base list",
    NoBlocksForTemplate: "You have not added any blocks to this template",
    NoCalculatedFields: "There are no calculated fields for this list",
    NoCalculatedFieldsForEntity: "You have not added any calculated fields to this list",
    NoCalculatedFieldsForExport: "You have not selected any calculated fields to export",
    NoCalculatedVariables: "You have not added any calculated variables",
    NoCalculations: "There are no calculations for this connector",
    NoClientInstructionsAdded: "You have not added any client instructions",
    NoClientMappingsAdded: "You have not added any client mappings",
    NoColorCodingRules: "You have not added any color coding rules",
    NoColorGradientsAdded: "You have not added any color gradients",
    NoColorPalettesHaveBeenAdded: "No color palettes have been added",
    NoColors: "You do not have any colors",
    NoColorsAdded: "You have not added any colors",
    NoColorsHaveBeenAddedPalette: "No colors have been added to this palette",
    NoColorsSelected: "You have not selected any colors",
    NoColumnFilters: "This column does not have any filters",
    NoColumnsAdded: "You have not added any columns",
    NoColumnsSelected: "No columns have been selected",
    NoCompaniesSelected: "No {0} have been selected",
    NoComponentsAdded: "You have not added any components",
    NoConditionsAdded: "You have not added any conditions",
    NoConnectorToExport: "You have not selected a connector to export",
    NoConnectorVariables: "You have not added any connector variables",
    NoConnectorsFound: "No connectors found",
    NoConnectorsInAccount: "There are no connectors in this account",
    NoConnectorsMatch: "No connectors match.",
    NoConnectorsToUpload: "You do not have any connectors installed that can be uploaded",
    NoCreditCard: "You do not have a credit card saved",
    NoCustomDateFiltersAdded: "You have not added any custom date filters",
    NoCustomEntities: "You have not added any custom lists for this connector",
    NoDashboards: "You have not added any dashboards",
    NoDefaultColumns: "There are no default columns for this list",
    NoDefaultFields: "There are no default fields for this list",
    NoDependencies: "You have not added any dependencies",
    NoDetails: "There are no details for this list",
    NoDetailsAdded: "You have not added any details",
    NoDetailsForConnector: "There are no details for this connector",
    NoDimensionsLoaded: "No dimensions were loaded",
    NoDomainRestrictions: "You have not restricted the widget to any domains",
    NoEmailSignaturesAdded: "You have not added any email signatures",
    NoEmailTemplatesAdded: "You have not added any email templates",
    NoEndpoints: "You do not have any endpoints",
    NoEndpointsAdded: "You have not added any endpoints",
    NoEntities: "You have not added any lists",
    NoEntitiesForAddFields: "You have not added any lists. You must add a list before adding fields.",
    NoEntitiesForConnector: "There are no lists for this connector",
    NoEntitiesForWidget: "There are no lists for this widget",
    NoEntitiesQueryBuilder: "You have not added any lists with the query builder",
    NoEntitiesSelected: "You have not selected any lists",
    NoEntitiesToAdd: "There are no lists to be added",
    NoEntriesMatchSelectedFilters: "No entries match the selected filters",
    NoErrorCodes: "You have not added any retry error codes",
    NoErrors: "No errors found",
    NoExcelTemplatesAdded: "You have not added any Excel templates",
    NoExternalUsersAdded: "You have not added any external users",
    NoFavoritePromptsAdded: "You have not added any favorite prompts",
    NoFavoritesAdded: "You have not added any favorites",
    NoFavoritesForConnector: "There are no favorites for this connector",
    NoFavoritesForEntity: "There are no favorites for this list",
    NoFavoritesForExport: "You have not selected any favorites to export",
    NoFavoritesForTag: "This tag does not have any favorites",
    NoFavoritesForTeam: "There are no favorites for this team",
    NoFavoritesForUser: "There are no favorites for this user",
    NoFavoritesSelected: "You have not selected any favorites",
    NoFields: "You have not added any fields",
    NoFieldsForEntity: "There are no fields for this list",
    NoFieldsForLookup: "There are no fields for this lookup",
    NoFieldsForTool: "You have not added any fields to this tool",
    NoFieldsSelected: "You have not selected any fields",
    NoFieldsToMap: "There are no fields to map",
    NoFileFieldsForEntity: "There are no file fields for this list",
    NoFileSplits: "You have not added any file splits for this list",
    NoFilenameEntered: "You have not entered a filename",
    NoFilterVariables: "You have not added any filter variables",
    NoFilters: "You have not added any filters",
    NoFiscalPeriods: "You have not added any fiscal periods",
    NoFiscalYears: "You have not added any fiscal years",
    NoFiscalYearsForConnector: "This connector does not have any fiscal years",
    NoFiscalYearsSelected: "You have not selected any fiscal years",
    NoFlows: "You have not added any flows",
    NoFormBodyFieldsAdded: "You have not added any form body fields",
    NoFormFields: "You do not have any form fields on this action",
    NoFormFieldsAdded: "You have not added any form fields",
    NoFormFieldsForAction: "There are no form fields for this action",
    NoFormWidgetsAdded: "You have not added any form widgets",
    NoGlobalVariables: "There are no global variables",
    NoGlobalVariablesAdded: "You have not added any global variables",
    NoGroupFields: "You have not added any group fields",
    NoGroups: "There are no groups for this connector",
    NoGroupsForTab: "You have not added any groups to this tab",
    NoGroupsForWidget: "There are no groups for this widget",
    NoHeaders: "There are no headers",
    NoHeadersForAction: "There are no headers for this action",
    NoHeadersForConnector: "There are no headers for this connector",
    NoHeadersForEntity: "There are no headers for this list",
    NoHiddenFieldsAdded: "You have not added any hidden fields",
    NoHiddenFieldsForAction: "There are no hidden fields for this action",
    NoHomePageContent: "You have not added any content to your home page",
    NoIconsAdded: "You have not added any icons",
    NoImagesAdded: "You have not added any images",
    NoInsights: "You have not added any insights",
    NoInvoices: "You do not have any invoices",
    NoInvoicesApplied: "There are no invoices applied",
    NoInvoicesFound: "No invoices found.",
    NoIpAddressesForFirewall: "You have not added any IP addresses to this firewall",
    NoIpAddressesForVirtualNetwork: "You have not added any IP addresses to this virtual network",
    NoItems: "There are no items",
    NoItemsForColumn: "There are no items in this column",
    NoItemsForForm: "There are no items for this form",
    NoJobs: "You have not added any scheduled jobs",
    NoJoins: "You have not added any joins",
    NoKeyFieldsForEntity: "There are no key fields for this list",
    NoKnowledgeBasesAdded: "You have not added any knowledge bases",
    NoListItems: "There are no list items for this list",
    NoListItemsAdded: "You have not added any list items",
    NoListItemsToCopyFor: "There are no list items to copy for this connector",
    NoListsFoundIn: "No lists were found in {0}.",
    NoListsHaveBeenUploaded: "No lists have been uploaded",
    NoLookups: "You have not added any lookups",
    NoLookupsList: "There are no lookups for this list",
    NoManagementReportsAdded: "You have not added any management reports",
    NoMatchingFavorites: "No favorites match your search.",
    NoMatchingFields: "You have not added any matching fields",
    NoMcpClientsAdded: "You have not added any MCP clients",
    NoMcpPromptsExecutedInThis: "There were no MCP prompts executed in this period",
    NoMcpServersAdded: "You have not added any MCP servers",
    NoMcpToolsExecutedInThis: "There were no MCP tools executed in this period",
    NoMessagesAdded: "You have not added any messages",
    NoMobileAppsAdded: "You have not added any mobile apps",
    NoNotificationRecipients: "No one will be emailed about this account's task usage.",
    NoOptimizationsForEntity: "There are no optimizations for this list",
    NoOptionalParameters: "There are no optional parameters",
    NoOptionsSelected: "You have not selected any options",
    NoOptionsToExport: "You have not selected any resources to export",
    NoOutputFieldsAdded: "You have not added any output fields",
    NoOwnedFavoritesForUser: "This user does not own any favorites",
    NoOwnedWidgetsForUser: "This user does not own any widgets",
    NoPagesForDashboard: "You have not added any pages to this dashboard",
    NoParameters: "There are no parameters",
    NoParametersAdded: "You have not added any parameters",
    NoParametersForAction: "There are no parameters for this action",
    NoParametersForConnector: "There are no parameters for this connector",
    NoParametersForDetail: "There are no parameters for this detail",
    NoParametersForEndpoint: "There are no parameters for this endpoint",
    NoParametersForEntity: "There are no parameters for this list",
    NoParametersForPrompt: "You have not added any parameters to this prompt",
    NoParametersForSidebar: "There are no parameters for this group widget",
    NoParametersForTool: "You have not added any parameters to this tool",
    NoParametersForWidget: "You have not added any parameters to this widget",
    NoPartnerUsers: "You have not granted access to any partner users",
    NoPaymentMethodsAdded: "You have not added any payment methods",
    NoPayments: "There are no payments",
    NoPdfTemplatesAdded: "You have not added any PDF templates",
    NoPlaceholderUsers: "You have not granted access to any {0} users",
    NoPlansAvailable: "No plans are available right now",
    NoPrebuiltPromptsForConnector: "No prebuilt prompts are available for {0} yet. You can add prompts from the MCP server page after setup.",
    NoPrebuiltToolsForConnector: "No prebuilt tools are available for {0} yet. You can add tools from the MCP server page after setup.",
    NoPromptsForServer: "You have not added any prompts to this server",
    NoPromptsForThirdPartyServer: "You have not added any prompts to this MCP server",
    NoPublicHolidaysAdded: "You have not added any public holidays",
    NoQueriesAdded: "You have not added any queries",
    NoQueriesRunInThisPeriod: "There were no queries run in this period",
    NoQueryBuilderEntitiesAdded: "You have not added any Query Builder lists",
    NoRedactionMethodsAdded: "You have not added any redaction methods",
    NoRedirectUrisAddedCannotSignIn: "This app cannot sign anyone in until you add at least one redirect URI.",
    NoRelationships: "There are no relationships for this list",
    NoReportingTreeItemsAdded: "You have not added any reporting tree items",
    NoReportingTrees: "You have not added any reporting trees",
    NoResourceHistory: "This resource does not have any history",
    NoResources: "You have not added any resources",
    NoResourcesForServer: "You have not added any resources to this server",
    NoResourcesForThirdPartyServer: "You have not added any resources to this MCP server",
    NoResourcesToExport: "You have not selected any resources to export",
    NoRestrictions: "You have not added any restrictions",
    NoRestrictionsForField: "There are no restrictions for this field",
    NoRestrictionsListMissing: "You have not added any restrictions. You have to select a list before you can add restrictions.",
    NoReturnFieldsForAction: "You have not added any return fields for this action",
    NoRoles: "You have not added any roles",
    NoRowFilters: "This row does not have any filters",
    NoRows: "You have not added any rows",
    NoRules: "You have not added any rules",
    NoSandboxes: "You have not added any sandboxes",
    NoSearchResults: "The search returned no results",
    NoSectionsForKnowledgeBase: "You have not added any sections to this knowledge base",
    NoSecurityRolesTeam: "This team does not have any security roles",
    NoSecurityRolesUser: "This user does not have any security roles",
    NoSelectedFields: "You have not selected any fields",
    NoSharedFavoritesForUser: "This user does have any favorites shared with them",
    NoShippingDetails: "There are no shipping details for this tracking number",
    NoSidebars: "You have not added any group widgets",
    NoSortingAdded: "You have not added any sorting",
    NoStylesAdded: "You have not added any styles",
    NoSummaryFields: "You have not added any summary fields",
    NoSupportUsers: "You have granted access to any support users",
    NoSvgCardsAdded: "You have not added any SVG cards",
    NoTablesForQuery: "You have not selected any tables for the query",
    NoTablesOrEntitiesFoundFor: "No tables or entities found for {0}.",
    NoTablesToAdd: "There are no tables to be added",
    NoTableStylesAdded: "You have not added any table styles",
    NoTabs: "You have not added any tabs",
    NoTabsForSidebar: "You have not added any tabs to the group widget",
    NoTags: "You have not added any tags",
    NoTagsCreatedYet: "No tags created yet.",
    NotAllRequiredConnectionSettingsHave: "Not all required connection settings have been entered.",
    NoTasksYet: "No tasks yet.",
    NoteAddOnsProrated: "Your plan and renewal date are unchanged. Add-ons are prorated for the rest of this period.",
    NoTeamMembers: "This team does not have any members",
    NoTeams: "You have not added any teams",
    NoTeamsForConnector: "There are no teams with access to this connector",
    NoteBillingAndAddOns: "Add-ons are prorated from today; billing moves to {0} on {1}.",
    NoteBillingAndAddOnsAtRenewal: "Add-ons are prorated from today; billing moves to {0} on {1}.",
    NoteBillingSwitchTakesEffect: "You stay on {0}. The switch to {1} billing takes effect on {2}.",
    NoteCancelInPortalKeepsFeatures: "Once you cancel there, you keep {0} features until {1}. After that your connectors stop running, and nothing is deleted.",
    NoteCancelKeepsFeatures: "You keep {0} features until {1}. After that your connectors stop running, and nothing is deleted.",
    NoteChargedToCardOnFile: "Charged to the card on file. Cancel or change plan at any time from this page.",
    NoteDowngradeKeepsFeatures: "You keep {0} features until {1}, then move to {2}.",
    NoteFirstInvoiceProrated: "Your first invoice covers only the rest of the current billing period.",
    NoteFirstInvoiceProratedFullPrice: "Your first invoice covers only the rest of the current billing period. {0} {1} applies from your next billing date.",
    NoTemplatesAdded: "You have not added any templates",
    NoteUpgradeProratedDifference: "You are charged the prorated difference now; the full {0} applies from your next renewal on {1}.",
    NoTokens: "You have not added any tokens",
    NoTokensForUser: "This user does not have any tokens",
    NoToolsForConnector: "You have not added any tools to this connector",
    NoToolsForThirdPartyServer: "You have not added any tools to this MCP server",
    NoTransactionsFound: "No transactions found.",
    NoUnmappedFields: "There are no unmapped fields",
    NoUserInputsForTool: "You have not added any user inputs to this tool",
    NoUsersForMobileApp: "You have not added any users to this mobile app",
    NoUserVariables: "You have not added any user variables",
    NoUsers: "You have not added any users",
    NoUsersForConnector: "There are no users with access to this connector",
    NoUsersInvited: "No users were invited.",
    NoUsersSecurity: "There are no users to set security for",
    NoValidationsForParameter: "You have not added any validations to this parameter",
    NoValidationsForTool: "You have not added any validations to this tool",
    NoVariablesAdded: "You have not added any variables",
    NoVariablesForConnector: "You have not added any variables for this connector",
    NoVariantsAdded: "You have not added any variants",
    NoVersionsToCompare: "This item does not have multiple versions to compare.",
    NoVirtualNetworks: "You have not added any virtual networks",
    NoVirtualNetworksForFirewall: "You have not added any virtual networks for this firewall",
    NothingImported: "Nothing was imported. The file did not contain any resources to import.",
    NothingImportedForApp: "Nothing was imported. This app did not contain any resources to import.",
    NotReportedByImport: "{0} of the {1} in this file were not reported by the import service, so they may not have been created.",
    NoWidgetEnvironmentParameters: "You have not added any environment parameters",
    NoWidgetFields: "You have not selected any fields. This widget will display the default fields for the list.",
    NoWidgetGroupsAdded: "You have not added any widget groups",
    NoWidgetParameters: "There are no parameters for this widget",
    NoWidgetsAvailableToAdd: "There are no widgets available to add",
    NoWidgetSelected: "You have not selected a widget",
    NoWidgets: "You do not have any widgets",
    NoWidgetsAdded: "You have not added any widgets",
    NoWidgetsForTab: "You have not added any widgets to this tab",
    NoWidgetsPage: "You have not added any widgets to this page",
    NoWidgetsSidebar: "You have not added any widgets to this group widget",
    NoWidgetsToAdd: "There are no widgets to add",
    NotAvailableForSubscription: "This feature is not available for your current subscription",
    NoWidgetThemesAdded: "You have not added any widget themes",
    NoWidgetThemesHaveBeenAdded: "No widget themes have been added",
    NoWorksheetsAdded: "You have not added any worksheets",
    NumberInvalidEmails: "{0} email addresses were invalid.",
    NumberUsersInvited: "{0} users were invited.",
    OfIncludedInPlan: "of {0} included in {1}",
    OnboardingAiSummariesNeedTwoThings: "AI summaries need two things: an AI provider to write the summary, and a data source to read from. Pick one of each.",
    OnboardingAiSummaryIntro: "Popdock pulls fresh data from {0}, sends it to an AI model with your prompt, and delivers the summary on your schedule.",
    OnboardingBuildingIntro: "Hang tight, Popdock is doing the work. You can leave this page open or come back later; we'll keep going either way.",
    OnboardingConnectBelowToConfirm: "Connect below to confirm your credentials. Popdock stores them encrypted and installs your connector in the final step.",
    OnboardingConnectEachToConfirm: "Connect each one below to confirm your credentials. Popdock stores them encrypted and installs your connector in the final step.",
    OnboardingEmbedFormIntro: "Choose how end users will submit data into {0}. We'll generate a snippet in the next step.",
    OnboardingEmbedIntro: "Choose how your {0} data should appear in the host page. We'll generate a snippet in the next step.",
    OnboardingInviteIntro: "Bring teammates into your new workspace. Paste one or more email addresses — they'll get an invite to join. You can always do this later from Account settings.",
    OnboardingMcpIntro: "Pick which tools and prompts to expose. Claude, ChatGPT and other MCP clients will be able to call these against your {0} data.",
    OnboardingMcpTemplatelessIntro: "No prebuilt tools exist yet for {0}. Popdock connects {1} during the build step; your first get-data tool can be configured below once it is connected, or any time afterward from the MCP server page.",
    OnboardingMigrationIntro: "Popdock will copy a one-time snapshot of your {0} data into {1}.",
    OnboardingMigrationWireUp: "After that, we'll wire up {0} so you can blend legacy and modern data side-by-side.",
    OnboardingPickAGoal: "Pick one and we'll match you to the right connectors and walk you through setup. You can always add more later.",
    OnboardingPickLegacyConnectors: "Pick a legacy source to migrate from, a data lake to land it in, and optionally the modern ERP you're moving to.",
    OnboardingPickOneConnector: "Pick one connector to get started. You can add more later.",
    OnboardingQueryIntro: "Popdock will scaffold these into your {0} workspace so you can start querying, drilling, and exporting right away.",
    OnboardingScheduledEmailIntro: "Popdock pulls fresh data from {0} on your schedule, renders it as an attachment, and emails it to your recipients.",
    OnboardingSetupWillNotReopen: "Guided setup will not open again on its own. You can add connectors and everything else at any time from the sidebar.",
    OnboardingSkipForNow: "Go straight to the dashboard. You can add connectors and set everything up whenever you are ready.",
    OnboardingWorkspaceSetUp: "Your {0} workspace is set up. Here's what comes next.",
    OnboardingWorkspaceSetUpGeneric: "Your workspace is set up. Here's what comes next.",
    OnlyUseTrustedMcpServers: "Only use MCP servers from developers you trust. Popdock does not control which tools developers make available and cannot verify that they will work as intended or that they won't change.",
    OnYourSubscriptionToday: "On your subscription today",
    OpenAuthenticatorApp: "Open the authenticator app on your mobile device to view your authentication code",
    OpenConnectorDescription: "Edit credentials, lists, and fields.",
    OutputFieldNameExists: "An output field with this name already exists",
    PageRequiredForDashboardWidgets: "You need to add a page before you can add widgets",
    PagingReadFromResponseBody: "the response body",
    PagingReadFromResponseHeader: "a response header",
    PagingResponseHighlight: "The highlighted line is the value Popdock reads. Nothing is highlighted when the path does not match the response.",
    PagingSentAsRequestHeader: "a request header",
    PagingSentAsUrlParameter: "a URL parameter",
    PagingSummaryCursor: "Popdock sends {0} set to the token found at {1} in {2}, repeating until the API returns no token. Each request asks for {3} records.",
    PagingSummaryCustom: "Paging is handled by a custom script. There is nothing to configure here.",
    PagingSummaryItemCount: "Popdock requests the first page, reads the item count from {0} in {1}, divides it by {2} records per page, then fetches the remaining pages {3} at a time using {4}.",
    PagingSummaryNextPageLink: "Popdock follows the address at {0} in {1} until no next page is returned, asking for {2} records per request.",
    PagingSummaryNextPageNumber: "Popdock increases {0} by one and keeps going while {1} in {2} is true, asking for {3} records per request.",
    PagingSummaryNone: "Popdock makes one request and asks for {0} records, using {1} as {2}.",
    PagingSummaryPageCount: "Popdock requests the first page, reads the page count from {0} in {1}, then requests every remaining page number through {2}, {3} at a time, {4} records each.",
    PagingSummaryPageOffset: "Popdock starts at record 0, then sets {0} to the value at {1} from each response, continuing while {2} is true, {3} records at a time.",
    ParameterKeyExists: "A parameter with this key already exists",
    ParameterNameExists: "A parameter with this name already exists",
    PaymentDeclinedTryAnotherCard: "Your card was declined. Check the card details or try another payment method. Your selection has been kept.",
    PaymentMethodCouldNotBeAdded: "The card could not be added. Check the details and try again.",
    PaymentMethodCouldNotBeRemoved: "The payment method could not be removed.",
    PaymentMethodCouldNotBeUpdated: "The payment method could not be updated.",
    PaymentMethodsCouldNotBeLoaded: "Your payment methods could not be loaded.",
    PaymentRetryUpdateMethod: "We will retry on {0}. Update your payment method to avoid an interruption.",
    PdfTemplateNameExists: "A PDF template with this name already exists",
    PeriodNameExists: "A period with this name already exists",
    PlanAllowanceExceeded: "This account has used more tasks this month than the plan includes. Open the Subscription tab to review your plan.",
    PlanAllowanceUsedUp: "This account has used every task its plan includes this month. Open the Subscription tab to review your plan.",
    PlanStaysActiveUntilRenewal: "Your plan stays active until the end of the current period.",
    PlanTaglineEssentials: "For a single team getting data out of one or two systems.",
    PlanTaglinePremium: "For organizations embedding Popdock and connecting AI clients.",
    PlanTaglineProfessional: "For teams building dashboards and sharing data across departments.",
    PostalCodeIsNotAUsZip: "Enter a US ZIP code: 5 digits, or 5 digits plus 4 (for example 94107 or 94107-1234).",
    PremiumFeature: "This feature is only available for Popdock Premium subscriptions",
    PreviewFirstSummaryDescription: "See what the AI will send before it goes live.",
    PricesInCurrency: "Prices in {0}.",
    PricesInCurrencyProration: "Prices in {0}. Upgrades take effect immediately and are prorated; downgrades apply at the next renewal.",
    PricesInUsdProration: "Prices in USD. Upgrades take effect immediately and are prorated; downgrades apply at the next renewal.",
    Processing: "Processing...",
    ProcessSmartConnectErrorsMissingErrorId: "Make sure row is selected and Error Id field is added to list",
    PromptNameExists: "A prompt with this name already exists",
    PublishManyBcExtensions: "Bulk add resources",
    Publishing: "Publishing...",
    PublishingExtensionInvalidSubscription: "Publishing extensions is only available for Business subscriptions and above",
    QueryBuilderInvalidSubscription: "Query builder is only available for Business subscriptions and above",
    ReadMcpSetupGuideDescription: "Step-by-step for the most common clients.",
    ReadyToInstall: "Ready to install.",
    Recalculating: "Recalculating...",
    RemovePaymentMethodConfirmation: "Are you sure you want to remove this payment method?",
    RequestFailed: "Request failed ({0})",
    ResumeFromStep: "Resume from {0}.",
    RecordNotSelected: "A record has not been selected",
    RecordsNotFound: "Records not found",
    RedactionMethodNameExists: "A redaction method with this name already exists",
    RedirectUriMustBeAbsolute: "Redirect URI must be an absolute URL.",
    RedirectUriMustNotContainFragment: "Redirect URI must not contain a fragment.",
    RedirectUriRequired: "Redirect URI is required.",
    RedirectUriSchemeNotAllowed: "Redirect URI must use https, or http with a loopback address.",
    Refreshing: "Refreshing...",
    RefreshingCompanies: "Refreshing companies...",
    ReplaceHeadersFromConnector: "Replace headers from connector",
    ReplaceParametersFromConnector: "Replace parameters from connector",
    RepublishBcExtensions: "Remove all published resources and republish the selected resources",
    RequiredField: "This field is required",
    RequiredFieldsNotEntered: "Not all required fields have been entered",
    RequiredParametersHaveNotBeenEntered: "Required parameters have not been entered",
    RequiredVariableNeedsDefault: "Required variables must have a default value",
    RequiredByPrompts: "Required by {0}, so it can't be turned off.",
    ResourceNameExists: "A resource with this name already exists",
    RestConnectorHeadersIncluded: "The connector's headers are sent as well as these.",
    RestConnectorHeadersReplaced: "The connector's headers are not sent.",
    RestConnectorParametersIncluded: "The connector's URL parameters are sent as well as these.",
    RestConnectorParametersReplaced: "The connector's URL parameters are not sent.",
    RestOptimizationNoneYet: "There are no optimizations yet, so Popdock fetches the records first and applies every filter itself.",
    RestOptimizationNotSent: "This optimization is not sent, because it has no field or no key. Popdock applies the filter to the records itself after they come back.",
    RestOptimizationSelectRow: "Select an optimization to see what it makes Popdock do.",
    RestOptimizationSummaryBody: "When a user filters this list on {0} with {1}, Popdock sends the value to the API as the body field {2} instead of filtering the records itself.",
    RestOptimizationSummaryHeader: "When a user filters this list on {0} with {1}, Popdock sends the value to the API as the request header {2} instead of filtering the records itself.",
    RestOptimizationSummaryParameter: "When a user filters this list on {0} with {1}, Popdock sends the value to the API as the URL parameter {2} instead of filtering the records itself.",
    RestOptimizationSummaryPlaceholder: "When a user filters this list on {0} with {1}, Popdock sends the value to the API in place of the {2} placeholder in the endpoint instead of filtering the records itself.",
    RestParametersPreviewNotes: "Struck-through rows are not sent: they have no key, or they are set to be removed when their value is empty.",
    RestParametersSummary: "Popdock sends every request to {0} as a {1}, adding the URL parameters, headers and body fields below.",
    ResumeStartsANewTerm: "Resuming starts a new billing term and charges the card on file today.",
    RetrieveRecordsFromSelectedTable: "Retrieve records from the selected table.",
    RetrieveRecordsFromTable: "Retrieve records from the {0} table.",
    ReturnFieldNameExists: "A return field with this name already exists",
    RevokeSecretCannotBeUndone: "Revoking this secret cannot be undone. Anything using it will no longer be able to sign in. Anyone already signed in stays signed in. To end those sessions, disable the app.",
    RootPathExplanation: "The part of the response the records sit under, as a path from the response root. Leave it blank to give every field a full path of its own. When it is set, each field path on this list is stored relative to it.",
    RoleHasNoUsers: "This role has no users assigned",
    RoleNameExists: "This role name already exists",
    RowNameExists: "A row with this name already exists",
    RunningPrompt: "Running prompt...",
    RunningTool: "Running tool...",
    SaveHomePageChanges: "Save changes and go back to your home page.",
    Saving: "Saving...",
    SchedulingJob: "Scheduling job...",
    SelectActionToSeeDetails: "Select an action to see its details.",
    SelectAiToneModifierToSeeDetails: "Select an AI tone modifier to see its details.",
    SelectAppRegistrationToSeeDetails: "Select an app registration to see its details.",
    SelectColorCodingRuleToSeeDetails: "Select a color coding rule to see its details.",
    SelectColorPaletteToSeeDetails: "Select a color palette to see its details.",
    SelectCompareListsBeforeFields: "Compare lists have not been selected. You must select both compare lists before you can add fields.",
    SelectConnectorBeforeFavorites: "You must select a connector before adding favorites",
    SelectDetailToSeeSettings: "Select a detail to see its settings.",
    SelectEndpointToSeeDetails: "Select an endpoint to see its details.",
    SelectEntityForFields: "Select a list from the dropdown above to edit the fields for the list",
    SelectEntityForRelationships: "Select a list from the dropdown above to edit the relationships for the list",
    SelectExternalUserToSeeDetails: "Select an external user to see their details.",
    SelectFavoriteBeforeParameters: "A favorite has not been selected. You must select a favorite before you can add parameters.",
    SelectFiscalYearToSeeDetails: "Select a fiscal year to see its details.",
    SelectFormBeforeParameters: "A form has not been selected. You must select a form before you can add parameters.",
    SelectGroupToSeeDetails: "Select a group to see its details.",
    SelectInvoiceToSeeDetails: "Select an invoice to see its details.",
    SelectJobToSeeDetails: "Select a job to see its details.",
    SelectListToStart: "Select a list to get started",
    SelectLookupToSeeDetails: "Select a lookup to see its details.",
    SelectMcpClientToSeeDetails: "Select an MCP client to see its details.",
    SelectParametersForWidgetPreview: "Select the parameters to pass to the widget, then click here to display the preview",
    SelectRedactionMethodToSeeDetails: "Select a redaction method to see its details.",
    SelectShippingServices: "Select the shipping services that you use:",
    SelectTableFieldOrJoinToEdit: "Select a table, field or join to edit",
    SelectTables: "Select tables and views",
    SelectTeamToSeeDetails: "Select a team to see its details.",
    SelectTransactionToSeeDetails: "Select a transaction to see its details.",
    SelectUsersForFavoriteImport: "Select the users you want to import favorites for",
    SelectUserToSeeDetails: "Select a user to see their details.",
    SendTestEmailNowDescription: "Run it once right now so you can see exactly what recipients get.",
    SendingTestMessage: "Sending test message...",
    SetUpConnectorFromConnectorsPage: "Set this connector up from the Connectors page, then come back.",
    SkippedBecauseMcpServerNotCreated: "Skipped because the MCP server {0} couldn't be created.",
    SkippedBecauseRequiredAppFailed: "Skipped because {0} didn't import.",
    SomeItemsCouldNotBeExported: "Some items could not be exported. The file has been saved without them.",
    SomeTemplatesFailedToImport: "Some templates failed to import — {0}",
    SomeToolsOrPromptsFailedToImport: "Some tools or prompts failed to import — {0}",
    SomethingWentWrong: "Something went wrong",
    SomethingWentWrongTryAgain: "Something went wrong. Please try again.",
    StartDateAfterEndDate: "The start date cannot be later than the end date",
    StartDateEqualsEndDate: "The start date and end date are the same",
    StartDateGreaterThanEndDate: "The start date is greater than end date",
    StartDateMustBeBeforeEndDate: "The start date must be before the end date",
    StartTimeMustBeforeEndTime: "The start time must be before the end time",
    StartUsing: "Now that you know everything (at least the Popdock-related everything), you can now start using Popdock to get all the data you need",
    StartingProcess: "Starting process...",
    StateIsNotAUsState: "Enter a US state or territory, either its two letter code or its full name.",
    SupportAccessDescription: "This permits new time-limited support access. Turning it off does not end access already granted; inactivate that support user or let the grant expire.",
    SubmitsToConnector: "Submits to {0}",
    SubscriptionAddOnsUpdated: "Add-ons updated.",
    SubscriptionBillingPeriodUpdated: "Billing period updated.",
    SubscriptionCancelled: "Subscription cancelled.",
    SubscriptionCancelsKeepFeatures: "You keep every feature until then. After that your connectors stop running, and nothing is deleted.",
    SubscriptionCancelsOnDate: "Cancels on {0}.",
    SubscriptionCannotBeResumed: "This subscription cannot be resumed. Choose a plan below to restore access.",
    SubscriptionChangesAtRenewal: "Your plan, billing period and add-ons all change at your next renewal.",
    SubscriptionCouldNotBeCancelled: "Your subscription could not be cancelled. Nothing has changed, so you can try again.",
    SubscriptionCouldNotBeResumed: "Your subscription could not be resumed. Nothing has changed, so you can try again.",
    SubscriptionCouldNotBeStarted: "Your subscription could not be started. No payment has been taken, so you can try again.",
    SubscriptionCouldNotBeUpdated: "Your subscription could not be updated. No change has been made, so you can try again.",
    SubscriptionResumed: "Subscription resumed.",
    SubscriptionStartsToday: "Your subscription starts today.",
    SubscriptionUpdated: "Subscription updated.",
    SuggestNewConnector: "Suggest a new connector",
    SvgCardNameExists: "A SVG card with this name already exists",
    TaskUsageNotificationsDescription: "These addresses are emailed when this account is on course to use all of its monthly tasks before the month ends. A recipient can be anyone, including a shared mailbox that is not a Popdock user.",
    TablePlaceholder: "Table: {0}",
    TabNameExists: "A tab with this name already exists",
    TagExists: "This tag already exists",
    TagNameExists: "A tag with this name already exists",
    TeamNameExists: "This team name already exists",
    TaskUsageRecipientExists: "This address is already a recipient",
    TaskUsageRecipientUnsubscribed: "This recipient unsubscribed from the link in an email and will not be emailed again. Only they can undo this.",
    TemplateNameExists: "A template with this name already exists",
    TestEmbedDescription: "Open a sandbox page to see it render live.",
    ThemeFormDescription: "Match your portal's fonts, colors, and field layout.",
    ThemeWidgetDescription: "Match your portal's fonts and colors.",
    Time24Hour: "All times must be entered in 24 hour format",
    TokenNameExists: "A token with name already exists",
    ToolHasNoParameters: "This tool does not have any parameters",
    ToolNameExists: "A tool with this name already exists",
    TrialExpired: "Your Popdock trial has expired",
    TrialExpiredContactAdmin: "Your connectors and favorites are still here. Contact your account administrator to turn them back on.",
    TrialExpiredResubscribe: "Your connectors and favorites are still here. Resubscribe to turn them back on.",
    TryingAlternativeParameters: "Trying alternative parameters...",
    UnableToConnectToEnvironmentConnector: "Unable to establish a connection with environment connector",
    UnableToLoadPlans: "We could not load the available plans. Please try again.",
    UnableToPriceChange: "We could not get a price for this change. Retry, or try again later.",
    UnableToPricePurchase: "We could not get a price for this purchase. Retry, or try again later.",
    Unsubscribed: "You are now unsubscribed",
    UpdatePaymentMethodToContinue: "Update your payment method to keep your subscription active.",
    UpdatingSelectedItems: "Updating selected items...",
    UpgradeTakesEffectImmediately: "Your upgrade takes effect immediately.",
    UsageExplanationActions: "Push updates back to a source from a query result.",
    UsageExplanationMcpPrompts: "Saved instructions your AI client can call by name.",
    UsageExplanationMcpTools: "Let an AI client read your data through an MCP server.",
    UsageExplanationQueries: "Run a list to pull data from a connected system.",
    UserNotInAnyTeams: "This user has not been added to any teams",
    UseSampleSettings: "Use the sample settings to test this connector",
    UserHasNoRoles: "This user is not a member of any roles",
    UserHasNoTeams: "This user is not a member of any teams",
    Validating: "Validating...",
    ValidatingConnection: "Validating connection...",
    ValidatingDatabase: "Validating database connection...",
    ValidationRuleNameExists: "A validation rule with this name already exists",
    VariableNameExists: "A variable with this name already exists",
    VersionAssignmentNotSaved: "The version assignment could not be saved. Refresh the page and try again.",
    ViewFirstListDescription: "Pick a list to open, then filter and export.",
    ViewMigrationLogDescription: "Row counts and any errors per table.",
    ViewPastRunsDescription: "Once scheduled, your summary history lives here.",
    VirtualNetworkNameAlreadyExists: "This virtual network name already exists",
    VirtualNetworksFirewallsCannotRemoved: "Virtual networks with firewalls cannot be removed",
    WaitingForUserInput: "Waiting for user input",
    Welcome: "Welcome to Popdock",
    WelcomeEnd: "Popdock is now set up and ready to go. ",
    WelcomeStart: "Before you can use Popdock, we need to know some information about the applications that you use.",
    WhatApplicationTypes: "What types of applications do you use?",
    WhereToFindConnectorSetupInfo: "Where do I find the information I need?",
    WidgetExampleConnectorAndEntity: "e.g. {0} · {1}",
    WidgetGroupNameExists: "A widget group with this name already exists",
    WidgetNameExists: "A widget with this name already exists",
    WidgetPublishedSuccessfully: "Your widget has been successfully published",
    WidgetTemplateKpiDescription: "Single-metric tile that auto-refreshes on a schedule.",
    WidgetTemplateListDescription: "Vertical record list, great for sidebars and portals.",
    WidgetTemplateSearchDescription: "A single search box that opens a record card on select.",
    WidgetTemplateTableDescription: "Full-featured table with search, sort, filter, and export.",
    WildcardsNotAllowedInRedirectUri: "Wildcards are not allowed in a redirect URI.",
    WrongCredentials: "Username/password were not correct",
    YouAreBilledAmount: "You are billed {0} {1}.",
    YouAreBilledAmountIncludingAddOn: "You are billed {0} {1}, including 1 add-on.",
    YouAreBilledAmountIncludingAddOns: "You are billed {0} {1}, including {2} add-ons.",
    YouAreNowOnPlan: "You are now on {0}.",
    YouCanLeaveThisOpen: "You can leave this open — we'll keep going.",
    YouDontHaveAccess: "You don't have access to this page",
};
